interface IHelpContentProps {
  content: string;
}

const HelpContent = ({ content }: IHelpContentProps) => {
  return (
    <div
      className='help__content'
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default HelpContent;
